import { AutoComplete } from "primereact/autocomplete";

import React, { useEffect, useState } from "react";

import { DEVICE_MAPPINGS } from "./device/DeviceDetail";

import "./SearchBar.css";
import { formatValue } from "../lib/text";
import { useLocation, useNavigate } from "react-router-dom";
import InfoButton from "./screen/Info";



const formatTag = (key, value) => {
  return `${key}: ${formatValue(value)}`
}

/*
 * SearchBar Component with input and autocompletion
 * Handles keyboard events
 * key arrows up and down to navigate through suggestions
 */
const SearchBar = ({
  suggestionList,
  onFilter,
  hashTagOnly = false,
  mapKeyValues = DEVICE_MAPPINGS,
  placeholder = "Suche...",
  preFiltered = [],
}) => {
  const [value, setValue] = useState(preFiltered);
  const [items, setItems] = useState([])
  const [isUpdatingFromForm, setIsUpdatingFromForm] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Funktion zum Aktualisieren der URL basierend auf den aktuellen Filtern
  const updateURL = (filters) => {
    setIsUpdatingFromForm(true);
    setTimeout(() => {
      setIsUpdatingFromForm(false);
    }, 500);

    if (filters.length === 0) {
      // Entferne Hash, wenn keine Filter vorhanden sind
      navigate(location.pathname, { replace: true });
    } else {
      // Konvertiere Filter zurück zum URL-Format
      const urlFilters = filters.map(filter => {
        if (hashTagOnly && filter.startsWith('#')) {
          return filter.substring(1);
        } else {
          // Finde den ursprünglichen Key für das mapping
          const colonIndex = filter.indexOf(': ');
          if (colonIndex > 0) {
            const displayKey = filter.substring(0, colonIndex);
            const value = filter.substring(colonIndex + 2);

            // Finde den ursprünglichen Key
            const originalKey = Object.keys(mapKeyValues).find(key => mapKeyValues[key] === displayKey);
            if (originalKey) {
              return `${originalKey}:${encodeURIComponent(value)}`;
            }
          }
          return filter;
        }
      });

      const hash = urlFilters.join(',');
      navigate(`${location.pathname}#${hash}`, { replace: true });
    }
  };


  const search = ({ query }) => {
    const found = []
    if (hashTagOnly) {
      suggestionList.forEach((item) => {
        const _item = item.replace("#", "")
        const _query = query.replace("#", "")
        if (_item.toLowerCase().includes(_query.toLowerCase())) {
          found.push(item)
        }
      })
    } else {
      suggestionList.forEach((item) => {
        Object.keys(mapKeyValues).forEach((key) => {
          if (typeof item[key] === "string" && item[key].toLowerCase().includes(query.toLowerCase())) {
            found.push(formatTag(mapKeyValues[key], item[key]))
          }
          if (Array.isArray(item[key])) {
            item[key].forEach((_value) => {
              if (typeof _value === "string" && _value.toLowerCase().includes(query.toLowerCase())) {
                found.push(formatTag(mapKeyValues[key], _value))
              }
            })
          }
          if (mapKeyValues[key].toLowerCase().includes(query.toLowerCase())) {
            if (Array.isArray(item[key])) {
              item[key].forEach((_value) => {
                found.push(formatTag(mapKeyValues[key], _value))
              })
            } else {
              found.push(formatTag(mapKeyValues[key], item[key]))
            }
          }
        })
      })
    }
    setItems([...new Set(
      found
        .filter((s) => !value.includes(s))
        .map((s) => s.trim())
    )])
  };

  useEffect(() => {
    onFilter(value);
    // Aktualisiere URL nur wenn nicht gerade von URL geladen wird
    if (!isUpdatingFromForm) {
      updateURL(value);
    }
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (isUpdatingFromForm) {
      console.log("Skipping URL update due to isUpdatingFromForm");
      return; // Verhindert Endlosschleife
    }
    if (location.hash.length > 0) {
      const filters = decodeURIComponent(location.hash.substring(1)).split(",");
      const newFilters = [];

      filters.forEach((filter) => {
        const [key, value] = filter.split(":");
        if (key && value) {
          const filterObj = `${mapKeyValues[key]}: ${value}`
          newFilters.push(filterObj);
        } else if (key && hashTagOnly) {
          const filterObj = `#${key.replace("#", "")}`
          newFilters.push(filterObj);
        }
      });

      if (newFilters.length > 0) {
        setValue(newFilters);
      }

    }
  }, [location.hash]); // eslint-disable-line react-hooks/exhaustive-deps


  return (
    <div className="card p-fluid search-bar-wrapper">
      <AutoComplete
        value={value}
        suggestions={items}
        completeMethod={search}
        onChange={(e) => setValue(e.value)}
        multiple
        placeholder={placeholder}
      />
      <InfoButton>
        Suche nach folgenden Kriterien möglich:
        <ul>
          {Object.values(mapKeyValues).map((item, index) => (
            <li key={index}>{item}&nbsp;</li>
          ))}
        </ul>
      </InfoButton>
    </div>
  );

};

export default SearchBar;
